import { EquipmentType } from "@cf-shared/data-model/equipment";
// type-only import, so this never becomes a runtime import cycle
import type { EquipmentTemplate } from "./equipment-templates";

export const equipmentTemplatesEU: EquipmentTemplate[] = [
  {
    id: '$barbell',
    type: EquipmentType.Bar,
    nameKey: 'barbell',
    weight_unit: 'kg',
    bar_kg: 20,
    collar_kg: 0,
    plates: [
      { weight_kg: 25 },
      { weight_kg: 25 },
      { weight_kg: 25 },
      { weight_kg: 25 },
      { weight_kg: 20 },
      { weight_kg: 20 },
      { weight_kg: 15 },
      { weight_kg: 10 },
      { weight_kg: 5 },
      { weight_kg: 5 },
      { weight_kg: 2.5 },
      { weight_kg: 2.5 },
      { weight_kg: 1.25 },
    ],
  },
  {
    id: '$dumbbells',
    nameKey: 'dumbbells',
    type: EquipmentType.Fixed,
    weight_unit: 'kg',
    fixed: [
      { weight_kg: 1 },
      { weight_kg: 2 },
      { weight_kg: 3 },
      { weight_kg: 4 },
      { weight_kg: 5 },
      { weight_kg: 6 },
      { weight_kg: 7 },
      { weight_kg: 8 },
      { weight_kg: 9 },
      { weight_kg: 10 },
      { weight_kg: 12.5 },
      { weight_kg: 15 },
      { weight_kg: 17.5 },
      { weight_kg: 20 },
      { weight_kg: 22.5 },
      { weight_kg: 25 },
      { weight_kg: 27.5 },
      { weight_kg: 30 },
      { weight_kg: 32.5 },
      { weight_kg: 35 },
      { weight_kg: 37.5 },
      { weight_kg: 40 },
      { weight_kg: 42.5 },
      { weight_kg: 45 },
      { weight_kg: 47.5 },
      { weight_kg: 50 },
    ],
    plates: [],
  },
  {
    id: '$plates',
    type: EquipmentType.Plates,
    nameKey: 'freePlates',
    weight_unit: 'kg',
    plates: [
      { weight_kg: 25 },
      { weight_kg: 25 },
      { weight_kg: 25 },
      { weight_kg: 25 },
      { weight_kg: 20 },
      { weight_kg: 20 },
      { weight_kg: 15 },
      { weight_kg: 10 },
      { weight_kg: 5 },
      { weight_kg: 5 },
      { weight_kg: 2.5 },
      { weight_kg: 2.5 },
      { weight_kg: 1.25 },
    ],
  },
  {
    id: '$kettlebells',
    nameKey: 'kettlebells',
    type: EquipmentType.Fixed,
    weight_unit: 'kg',
    fixed: [
      { weight_kg: 2 },
      { weight_kg: 4 },
      { weight_kg: 8 },
      { weight_kg: 12 },
      { weight_kg: 16 },
      { weight_kg: 20 },
      { weight_kg: 24 },
      { weight_kg: 28 },
      { weight_kg: 32 },
      { weight_kg: 36 },
    ],
    plates: [],
  },
  {
    id: '$cable',
    type: EquipmentType.Stack,
    nameKey: 'cableMachine',
    weight_unit: 'kg',
    stack: [
      { totalWeight_kg: 2.5 },
      { totalWeight_kg: 5 },
      { totalWeight_kg: 7.5 },
      { totalWeight_kg: 10 },
      { totalWeight_kg: 12.5 },
      { totalWeight_kg: 15 },
      { totalWeight_kg: 17.5 },
      { totalWeight_kg: 20 },
      { totalWeight_kg: 22.5 },
      { totalWeight_kg: 25 },
      { totalWeight_kg: 27.5 },
      { totalWeight_kg: 30 },
      { totalWeight_kg: 32.5 },
      { totalWeight_kg: 35 },
      { totalWeight_kg: 37.5 },
      { totalWeight_kg: 40 },
      { totalWeight_kg: 42.5 },
      { totalWeight_kg: 45 },
      { totalWeight_kg: 47.5 },
      { totalWeight_kg: 50 },
      { totalWeight_kg: 52.5 },
      { totalWeight_kg: 55 },
      { totalWeight_kg: 57.5 },
      { totalWeight_kg: 60 },
      { totalWeight_kg: 62.5 },
      { totalWeight_kg: 65 },
      { totalWeight_kg: 67.5 },
      { totalWeight_kg: 70 },
      { totalWeight_kg: 72.5 },
      { totalWeight_kg: 75 },
      { totalWeight_kg: 77.5 },
      { totalWeight_kg: 80 },
      { totalWeight_kg: 82.5 },
      { totalWeight_kg: 85 },
      { totalWeight_kg: 87.5 },
      { totalWeight_kg: 90 },
      { totalWeight_kg: 92.5 },
      { totalWeight_kg: 95 },
      { totalWeight_kg: 97.5 },
      { totalWeight_kg: 100 },
      { totalWeight_kg: 102.5 },
      { totalWeight_kg: 105 },
      { totalWeight_kg: 107.5 },
      { totalWeight_kg: 110 },
      { totalWeight_kg: 112.5 },
      { totalWeight_kg: 115 },
      { totalWeight_kg: 117.5 },
      { totalWeight_kg: 120 },
      { totalWeight_kg: 122.5 },
      { totalWeight_kg: 125 },
      { totalWeight_kg: 127.5 },
      { totalWeight_kg: 130 },
      { totalWeight_kg: 132.5 },
      { totalWeight_kg: 135 },
      { totalWeight_kg: 137.5 },
      { totalWeight_kg: 140 },
      { totalWeight_kg: 142.5 },
      { totalWeight_kg: 145 },
      { totalWeight_kg: 147.5 },
      { totalWeight_kg: 150 },
      { totalWeight_kg: 152.5 },
      { totalWeight_kg: 155 },
      { totalWeight_kg: 157.5 },
      { totalWeight_kg: 160 },
      { totalWeight_kg: 162.5 },
      { totalWeight_kg: 165 },
      { totalWeight_kg: 167.5 },
      { totalWeight_kg: 170 },
      { totalWeight_kg: 172.5 },
      { totalWeight_kg: 175 },
      { totalWeight_kg: 177.5 },
      { totalWeight_kg: 180 },
      { totalWeight_kg: 182.5 },
      { totalWeight_kg: 185 },
      { totalWeight_kg: 187.5 },
      { totalWeight_kg: 190 },
      { totalWeight_kg: 192.5 },
      { totalWeight_kg: 195 },
      { totalWeight_kg: 197.5 },
      { totalWeight_kg: 200 },
    ],
    plates: [],
  },
  {
    id: '$custom',
    type: EquipmentType.Manual,
    nameKey: 'customIncrements',
    weight_unit: 'kg',
    weight_min_kg: 0,
    weight_inc_kg: 2.5,
  },
];
